import { z } from "zod";
import { BLOCK, DIST_STATUS, DIST_TYPE, FISCAL_YEAR, GL_MASTER_IDS, MONTH_RANGE, PROPERTY, RECORD_TYPE, REPORTING_LEVEL, ZONE } from "./consts";

export const schema = z.object({
  [MONTH_RANGE]: z.object({
    from: z.date({
      required_error: "This field is required",
      invalid_type_error: "This field is required",
    }),
    to: z.date({
      required_error: "This field is required",
      invalid_type_error: "This field is required",
    })
  }),
  [REPORTING_LEVEL]: z.string().min(1, "This field is required"),
  [ZONE]: z.array(z.string()).optional(),
  [BLOCK]: z.array(z.string()).optional(),
  [PROPERTY]: z.array(z.string()).optional(),
  [FISCAL_YEAR]: z.string().optional(),
  [DIST_STATUS]: z.array(z.string()).optional(),
  [DIST_TYPE]: z.array(z.string()).optional(),
  [RECORD_TYPE]: z.string().optional(),
  [GL_MASTER_IDS]: z.array(z.string()).optional(),
});

export type formValues = z.infer<typeof schema>;